import service from '@/utils/service'

export const delContract = (id: any) =>
  service({ method: 'delete', url: `/hrm/contracts`, data: [id] })

export const addOrUpdateContract = (data: any) =>
  service({ method: 'post', url: '/hrm/contracts', data })

export const getContract = (employee_ids?: any[]) =>
  service({
    method: 'post',
    url: '/hrm/contracts/list',
    data: { paged: false, employee_ids }
  })
// 解除合同
export const relieveContracts = (data: any): any =>
  service({ method: 'put', url: '/hrm/contracts', data })
